module.exports = __webpack_public_path__ + "static/media/message0.5341dc56.svg";